import {watch} from "vue";
import {debounce} from 'lodash';
import {useDevice} from "@/composables/useDevice";
import {useSearchStore} from "@/stores/searchStore";

import * as events from '@/events';
import {useGroup} from "@/composables/useGroup";


export function useSynchronizedSearchGroupList() {
  const groupStore = useGroup();
  const searchStore = useSearchStore();
  const { setSearch } = groupStore;

  watch(searchStore, debounce((value) => {
    setSearch(value.normalizedQuery);
    events.trigger(events.names.GROUPS_SEARCHED, { query: value.normalizedQuery });
  }, 300), {
    immediate: true,
    flush: 'post',
  })
}
